export const amplienceImageLoader = ({ src, width }: { src: string; width: number }) => {
  return encodeURI(src) + '?fmt=auto&' + 'w=' + width + '&q=90';
};
